/**
 * LevelPanel utility functions
 */

export function isWebView() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }
  if (localStorage.getItem('isWebView') === 'true') {
    return true;
  }
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('webview') === 'true') {
    return true;
  }
  if (window.ReactNativeWebView) {
    return true;
  }
  if (window.__WEBVIEW__ || window.isWebView) {
    return true;
  }
  if (window.webkit?.messageHandlers && Object.keys(window.webkit.messageHandlers).length > 0) {
    return true;
  }
  const userAgent = navigator.userAgent || '';
  const userAgentLower = userAgent.toLowerCase();
  if (userAgentLower.includes('wv') && !userAgentLower.includes('chrome')) {
    return true;
  }
  return false;
}

/**
 * Find subcourse by level in course tree
 */
export function findSubcourseByLevel(tree, level) {
  let courses = [];
  if (Array.isArray(tree)) {
    courses = tree;
  } else if (tree && Array.isArray(tree.courses)) {
    courses = tree.courses;
  } else if (tree && typeof tree === 'object') {
    const possibleKeys = ['courses', 'data', 'courseTree', 'tree'];
    for (const key of possibleKeys) {
      if (Array.isArray(tree[key])) {
        courses = tree[key];
        break;
      }
    }
    if (courses.length === 0) {
      const values = Object.values(tree);
      const allArrays = values.filter((v) => Array.isArray(v));
      if (allArrays.length > 0) {
        courses = allArrays.flat();
      }
    }
  }

  if (courses.length === 0) return null;

  for (const course of courses) {
    if (!course.subcourses || !Array.isArray(course.subcourses)) continue;

    for (const subcourse of course.subcourses) {
      const subcourseCode =
        subcourse['subcourse-code'] || subcourse.subcourseCode || subcourse.code;
      const subcourseName = subcourse.name || subcourse.title;
      const subcourseLevel = subcourse.level || subcourse.levelCode;
      const matchValue = subcourseCode || subcourseName || subcourseLevel;

      if (
        matchValue &&
        matchValue.toString().toLowerCase() === level.toLowerCase()
      ) {
        return { ...subcourse, id: subcourse._id || subcourse.id };
      }
    }
  }
  return null;
}
